import Products from 'merchandise-lib/constants/Product';
// These features are moving down from the Enterprise tier to the Professional tier for HSoC pilot users.
// We cannot update the feature configs to associate these features with the Professional tier because
// that would impact users outside of the pilot. So we need to include this additional mapping layer.
// https://github.com/HubSpotEngineering/growth-ebx-planning/issues/1660
export const FEATURE_TO_HSOC_PRODUCT_MAP = {
  activityLogging: Products.CORE_SEATS_PROFESSIONAL_HSOC,
  aiCallTranscriptEnrichmentBeta: Products.CORE_SEATS_PROFESSIONAL_HSOC,
  codeAlerts: Products.CORE_SEATS_PROFESSIONAL_HSOC,
  conditionalSLAs: Products.FRONT_OFFICE_SEATS_PROFESSIONAL,
  emailSendTimeOptimizationBeta: Products.CORE_SEATS_PROFESSIONAL_HSOC,
  customBehavioralEvents: Products.CORE_SEATS_PROFESSIONAL_HSOC,
  customObjects: Products.CORE_SEATS_PROFESSIONAL_HSOC,
  customerJourneyAnalytics: Products.CORE_SEATS_PROFESSIONAL_HSOC,
  dealJourneyAnalytics: Products.CORE_SEATS_PROFESSIONAL_HSOC,
  emailSendFrequencyCap: Products.CORE_SEATS_PROFESSIONAL_HSOC,
  eventVisualizer: Products.CORE_SEATS_PROFESSIONAL_HSOC,
  capacityLimitsForLiveChat: Products.FRONT_OFFICE_SEATS_PROFESSIONAL,
  ticketCapacityLimitsForUsers: Products.FRONT_OFFICE_SEATS_PROFESSIONAL,
  journeyAutomationForMarketers: Products.CORE_SEATS_PROFESSIONAL_HSOC,
  leadFormRouting: Products.FRONT_OFFICE_SEATS_PROFESSIONAL,
  lookalikeLists: Products.CORE_SEATS_PROFESSIONAL_HSOC,
  marketingEmailSingleSendAPI: Products.CORE_SEATS_PROFESSIONAL_HSOC,
  multiTouchRevenueAttribution: Products.CORE_SEATS_PROFESSIONAL_HSOC,
  salesforceCustomObjectSync: Products.CORE_SEATS_PROFESSIONAL_HSOC,
  webApps: Products.CORE_SEATS_PROFESSIONAL_HSOC
};
export const HUB_TO_HSOC_PRODUCT_MAP = {
  [Products.CRM_SUITE_STARTER_BUNDLE]: Products.CORE_SEATS_STARTER_HSOC,
  [Products.MARKETING_HUB_STARTER]: Products.CORE_SEATS_STARTER_HSOC,
  [Products.MARKETING_HUB_PROFESSIONAL]: Products.CORE_SEATS_PROFESSIONAL_HSOC,
  [Products.MARKETING_HUB_ENTERPRISE]: Products.CORE_SEATS_ENTERPRISE_HSOC,
  [Products.CMS_HUB_STARTER]: Products.CORE_SEATS_STARTER_HSOC,
  [Products.CMS_HUB_PROFESSIONAL]: Products.CORE_SEATS_PROFESSIONAL_HSOC,
  [Products.CMS_HUB_ENTERPRISE]: Products.CORE_SEATS_ENTERPRISE_HSOC,
  [Products.OPERATIONS_HUB_STARTER]: Products.CORE_SEATS_STARTER_HSOC,
  [Products.OPERATIONS_HUB_PROFESSIONAL]: Products.CORE_SEATS_PROFESSIONAL_HSOC,
  [Products.OPERATIONS_HUB_ENTERPRISE]: Products.CORE_SEATS_ENTERPRISE_HSOC,
  [Products.SALES_HUB_STARTER]: Products.CORE_SEATS_STARTER_HSOC,
  [Products.SALES_HUB_PROFESSIONAL]: Products.FRONT_OFFICE_SEATS_PROFESSIONAL,
  [Products.SALES_HUB_ENTERPRISE]: Products.FRONT_OFFICE_SEATS_ENTERPRISE,
  [Products.SERVICE_HUB_STARTER]: Products.CORE_SEATS_STARTER_HSOC,
  [Products.SERVICE_HUB_PROFESSIONAL]: Products.FRONT_OFFICE_SEATS_PROFESSIONAL,
  [Products.SERVICE_HUB_ENTERPRISE]: Products.FRONT_OFFICE_SEATS_ENTERPRISE,
  [Products.COMMERCE_HUB_PROFESSIONAL]: Products.FRONT_OFFICE_SEATS_PROFESSIONAL,
  [Products.COMMERCE_HUB_ENTERPRISE]: Products.FRONT_OFFICE_SEATS_ENTERPRISE
};
export const mapProductForHubSpotOnCredits = upgradeConfig => {
  const originalApiName = upgradeConfig.bestFitApiNameForPurchase;
  if (!originalApiName) {
    return upgradeConfig;
  }
  const featureMappedApiName = FEATURE_TO_HSOC_PRODUCT_MAP[upgradeConfig.featureStoreFeature];
  const mappedApiName = featureMappedApiName !== null && featureMappedApiName !== void 0 ? featureMappedApiName : HUB_TO_HSOC_PRODUCT_MAP[originalApiName];
  if (!mappedApiName) {
    return upgradeConfig;
  }
  return Object.assign({}, upgradeConfig, {
    bestFitApiNameForPurchase: mappedApiName
  });
};